






































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import { mixins } from "vue-class-component";
import ImportPage from "@/lib/import-page";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";

class PageImportSaleOrderRequest extends PageRequest {
  soFileId: number;
}
@Component({
  components: {},
})
export default class ImportSaleOrder extends mixins(
  ListMixin,
  AbpBase,
  ImportPage
) {
  importPageName = "SaleOrder";
  namespace = "saleOrderImport";
  pagerequest: PageImportSaleOrderRequest = new PageImportSaleOrderRequest();

  //filters
  current: number = 0;
  saleOrderFileId: number = 0;
  spinShow: boolean = false;
  get store() {
    return this.$store.state.saleOrderImport;
  }
  get countItems() {
    return this.$store.state.saleOrderImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.saleOrderImport.countImportedItems;
  }
  preGetPage() {
    this.pagerequest.soFileId = this.saleOrderFileId;
  }
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "saleOrderImport/export",
      data: this.saleOrderFileId,
    });
  }
  columns = [
    {
      title: this.L("PriorityProcess"),
      width: 80,
      fixed: "left",
      key: "priorityProcess",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.priorityProcess));
      },
    },
    {
      title: this.L("ErrorMsg"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("SoCode"),
      width: 150,
      key: "soCode",
    },
    {
      title: this.L("WarehouseCode"),
      width: 150,
      key: "warehouseCode",
    },
    {
      title: this.L("BizType"),
      width: 100,
      key: "bizType",
    },
    {
      title: this.L("OutboundMode"),
      width: 100,
      key: "outboundMode",
    },
    {
      title: this.L("InventModel"),
      width: 100,
      key: "inventModel",
    },
    {
      title: this.L("ShippingService"),
      width: 100,
      key: "shippingServiceCode",
    },
    {
      title: this.L("IsNoPack"),
      width: 60,
      key: "isNoPack",
    },
    {
      title: this.L("IsLabelling"),
      width: 60,
      key: "isLabelling",
    },
    {
      title: this.L("IsShippable"),
      width: 60,
      key: "isShippable",
    },
    {
      title: this.L("COD"),
      width: 100,
      key: "cod",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.cod));
      },
    },
    {
      title: this.L("ShippingFee"),
      width: 100,
      key: "shippingFee",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.shippingFee));
      },
    },
    {
      title: this.L("ClientPickup"),
      width: 100,
      key: "isClientPickup",
    },
    {
      title: this.L("CustomerCode"),
      width: 150,
      key: "customerCode",
    },
    {
      title: this.L("CustomerName"),
      width: 150,
      key: "customerName",
    },
    {
      title: this.L("CustomerPhone"),
      width: 150,
      key: "customerPhone",
    },
    {
      title: this.L("ShippingDistrict"),
      width: 150,
      key: "shippingDistrictCode",
    },
    {
      title: this.L("ShippingWard"),
      width: 150,
      key: "shippingWardCode",
    },
    {
      title: this.L("ShippingAddressNo"),
      width: 150,
      key: "shippingAddressNo",
    },
    {
      title: this.L("SKU"),
      width: 150,
      key: "line_SKU",
    },
    {
      title: this.L("Price"),
      width: 100,
      key: "line_Price",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_Price));
      },
    },
    {
      title: this.L("Qty"),
      width: 100,
      key: "line_Qty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_Qty));
      },
    },
    {
      title: this.L("VATPercent"),
      width: 100,
      key: "line_VATPercent",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_VATPercent));
      },
    },
    {
      title: this.L("AssetTypeCode"),
      width: 100,
      key: "line_AssetTypeCode",
    },
    {
      title: this.L("ConditionTypeCode"),
      width: 100,
      key: "line_ConditionTypeCode",
    },
    {
      title: this.L("PackingNote"),
      width: 150,
      key: "packingNote",
    },
    {
      title: this.L("ShippingNote"),
      width: 150,
      key: "shippingNote",
    },
    {
      title: this.L("SyncToClientCode"),
      width: 150,
      key: "syncToClientCode",
    },
    {
      title: this.L("SyncToWarehouseCode"),
      width: 150,
      key: "syncToWarehouseCode",
    },
    {
      title: this.L("IsImported"),
      width: 80,
      fixed: "right",
      key: "isImported",
      align: "center",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  async created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.So", (notification) => {
        this.processNotifierImportSaleOrder(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.So", (notification) => {
          this.processNotifierImportSaleOrder(notification);
        });
      });
    }
  }
  processNotifierImportSaleOrder(notification: any) {
    if (notification.soFileId == this.saleOrderFileId) {
      this.$store.commit({
        type: "saleOrderImport/processNotifier",
        data: notification,
      });
    }
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("saleOrderImport/uploadImportSaleOrderFile", data)
          .then((res) => {
            this.resetList();
            this.resetCountItems();
            this.resetCountImportedItems();
            this.activeStep(true);
            this.spinShow = false;
            this.saleOrderFileId = res;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
